import { createTranslationObject } from '../helper';
import { Locale } from 'chaika-enums';
export const ruTranslations = createTranslationObject(Locale.Ru);
